import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { kanziSections } from "../../../../content/kanziSections";
import useBlurReveal from "../../../../hooks/useBlurReveal";
import Reveal from "../../Reveal";

const Manifesto = () => {
  const { containerRef, wordGroups } = useBlurReveal(
    kanziSections.manifesto.lines
  );

  return (
    <section className="manifesto-section">
      <div className="manifesto-section__inner">
        <div ref={containerRef}>
          <h2 className="manifesto-section__heading">
            {wordGroups.map((group, lineIndex) => (
              <span key={`line-${lineIndex}`} className="manifesto-section__line">
                {group.map((word, wordIndex) => {
                  const isAccent = kanziSections.manifesto.accentWords.includes(word);

                  return (
                    <span
                      key={`${word}-${wordIndex}`}
                      className={`reveal-word${isAccent ? " is-accent" : ""}`}
                    >
                      {word}&nbsp;
                    </span>
                  );
                })}
              </span>
            ))}
          </h2>
        </div>

        <div className="manifesto-section__cta-wrapper">
          <Reveal delay={200}>
            <Link
              to={kanziSections.manifesto.cta.href}
              className="inline-link group"
              title="Learn how Kanzi works"
            >
              <span>{kanziSections.manifesto.cta.label}</span>
              <ArrowRight size={24} strokeWidth={1.25} aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
      </div>

      <div className="glow-line manifesto-section__divider" />
    </section>
  );
};

export default Manifesto;
